var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('topTab',{ref:"topTab",attrs:{"tabData":_vm.tabData},on:{"tabChange":_vm.changePages}},[(_vm.activeTab == '1')?_c('realWarehouse',{ref:"realWarehouse"}):_vm._e(),(_vm.activeTab == '2')?_c('twoDimension',{ref:"twoDimension"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }